export const Dates = () => {
    return (
        <div class="pl-10 pr-10 pb-10 text-[#444444]">
            <h1>Coming soon!</h1>
            <h2>Sobald ich Termine für Kurse habe, werdet ihr sie hier finden!</h2>
        </div>
    )
}